import React, {useEffect} from "react";
import Layout from "@hoc/layouts/Layout";
import PageHeader from "@components/Pages/PageHeader";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Redirect} from "react-router-dom";
import {MdOutlinePictureAsPdf} from "react-icons/md";
import "./TransparencySectionContent.css";

export const transparencyCategories = [{"id": 1, "slug": "hyrje", "title": "Programi i Transparencës"}, {"id": 2, "slug": "rreth-autoritetit", "title": "Rreth autoritetit"}, {"id": 3, "slug": "kuadri-ligjor", "title": "Kuadri ligjor rregullator"}, {"id": 4, "slug": "e-drejta-e-informimit", "title": "E drejta për t'u informuar dhe për t'u ankuar"}, {"id": 5, "slug": "mekanizmat-kontrollues", "title": "Mekanizmat kontrollues dhe monitorues që veprojnë mbi AP"}, {"id": 6, "slug": "buxheti", "title": "Informacion mbi buxhetin dhe të dhënat financiare të AP"}, {"id": 7, "slug": "prokurimi", "title": "Informacion për procedurat e prokurimit/procedurat konkurruese të koncesionit/partneritetit publik privat"}, {"id": 8, "slug": "sherbimet", "title": "Shërbimet që ofrohen nga AP"}, {"id": 9, "slug": "konsultimi-publik", "title": "Procedurat/mekanizmat për të dhënë mendime lidhur me procesin e hartimit të akteve ligjore/nënligjore, politikave publike apo në lidhje me ushtrimin e funksioneve të AP"}, {"id": 10, "slug": "dokumentacioni", "title": "Sistemi i mbajtjes së dokumentacionit, llojet dhe format e dokumenteve"}, {"id": 11, "slug": "regjistri-i-kerkesave", "title": "Regjistri i kërkesave dhe përgjigjeve"}, {"id": 12, "slug": "ndihma-shoqerore", "title": "Ndihma shoqërore/subvencione të dhëna nga AP"}, {"id": 13, "slug": "informacione-dokumente", "title": "Informacione/dokumente që kërkohen më shpesh dhe ato që gjykohen të dobishme për publikim nga AP"}, {"id": 14, "slug": "te-dhenat-e-hapura", "title": "Të dhënat e hapura"}];
const sectionUrl = (id) => '/publications/transparency-program/sections/' + transparencyCategories.find(item => item.id === id).slug;

export const getSectionDocuments = (data, categoryId) => (data || []).filter(item =>
  item.category !== null && item.category !== undefined && item.category !== '' && Number(item.category) === categoryId
);

const ShowTransparencyProgramPage = ({match}) => {
  const {t, i18n} = useTranslation();
  const slug = match?.params?.section;
  const category = transparencyCategories.find(item => item.slug === slug);
  const allDocuments = useSelector(state => state.generalState?.transparencyPrograms || []);
  const documents = category ? getSectionDocuments(allDocuments, category.id) : [];
  const storedSections = useSelector(state => state.generalState?.transparencySections || []);
  const storedSection = category && storedSections.find(item => Number(item.id) === category.id);
  const language = i18n.language === 'en' ? 'en' : 'al';
  const sectionHtml = storedSection ? (language === 'en' && storedSection.content_en ? storedSection.content_en : storedSection.content_al) : null;

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  if (slug && !category) return <Redirect to="/publications/transparency-program/show" />;
  const defaultTransparencySchema = [
    {
      id: 1,
      title: "Programi i Transparencës",
      subtitle: "Hyrje",
      colspan: "full",
      link: "#"
    },
    // Row 1
    {
      id: 2,
      title: "Rreth autoritetit",
      link: "#rreth-autoritetit",
      row: 1
    },
    {
      id: 3,
      title: "Kuadri ligjor rregullator",
      subtitle: "Tekstet e plota",
      link: "#kuadri-ligjor",
      row: 1
    },
    {
      id: 4,
      title: "E drejta për t'u informuar dhe për t'u ankuar",
      link: "/publications/info",
      row: 1
    },
    // Row 2
    {
      id: 5,
      title: "Mekanizmat kontrollues dhe monitorues që veprojnë mbi AP",
      link: "#mekanizmat-kontrollues",
      row: 2
    },
    {
      id: 6,
      title: "Informacion mbi buxhetin dhe të dhënat financiare të AP",
      link: "/about-us/budget",
      row: 2
    },
    {
      id: 7,
      title: "Informacion për procedurat e prokurimit/procedurat konkurruese të koncesionit/partneritetit publik privat",
      link: "#prokurimi",
      row: 2
    },
    // Row 3
    {
      id: 8,
      title: "Shërbimet që ofrohen nga AP",
      link: "#sherbimet",
      row: 3
    },
    {
      id: 9,
      title: "Procedurat/mekanizmat për të dhënë mendime lidhur me procesin e hartimit të akteve ligjore/nënligjore, politikave publike apo në lidhje me ushtrimin e funksioneve të AP",
      link: "#procedurat-mendime",
      row: 3
    },
    {
      id: 10,
      title: "Sistemi i mbajtjes së dokumentacionit, llojet dhe format e dokumenteve",
      link: "#sistemi-dokumentacion",
      row: 3
    },
    // Row 4
    {
      id: 11,
      title: "Regjistri i kërkesave dhe përgjigjeve",
      link: "/publications/request-register",
      row: 4
    },
    {
      id: 12,
      title: "Ndihma shoqërore/subvencione të dhëna nga AP",
      link: "#ndihma-shoqerore",
      row: 4
    },
    {
      id: 13,
      title: "Informacione/dokumente që kërkohen më shpesh dhe ato që gjykohen të dobishme për publikim nga AP",
      link: "#informacione-dokumente",
      row: 4
    },
    {
      id: 14,
      title: "Të dhënat e hapura",
      row: 5
    }
  ];
  const transparencySchema = defaultTransparencySchema.map(item => {
    const stored = storedSections.find(section => Number(section.id) === item.id);
    return {...item, title: stored ? (stored['title_' + language] || stored.title_al || item.title) : item.title};
  });
  const sectionContent = {
    1: (<>
<h1 id={'transparency-section-1'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold'}>1. HYRJE</h1>
          <div className={'px-4 mt-4'}>
            <p className={'text-sm text-gray-600'}>
              Bazuar në nenin 7 të ligjit nr. 119/2014 “Për të drejtën e informimit” (në vijim “LDI”), Autoriteti Publik (në vijim “AP”) duhet të publikojë Programin e Transparencës (në vijim “PT”) të miratuar nga Komisioneri për të Drejtën e Informimit dhe Mbrojtjen e të Dhënave Personale (në vijim “Komisioneri”). AP duhet të publikoj informacion sipas veprimtarisë së tij funksionale si dhe të rishikoj e përditësoj PT në çdo rast të ndryshimit të aktivitetit institucional, kuadrit ligjor rregullator apo çdo elementi tjetër që ka lidhje me transparencën proaktive.
              Në PT janë të specifikuara kategoritë e informacionit të detyrueshëm për t’u bërë publik. Informacioni publik pa kërkesë duhet të jetë: i plotë, i saktë, i përditësuar, i thjeshtë në konsultim, i kuptueshëm, lehtësisht i aksesueshëm dhe i pajtueshëm me dokumentet origjinale në posedim të A.P. Gjithashtu, përpara publikimit të informacionit AP duhet të vlerësojë nësë ka ndonjë kufizim ligjor për publikim.
              Aktet që përmbajnë rregulla, norma apo kufizime të të drejtave dhe lirive themelore të individit, si dhe me efekt të drejtpërdrejtë për ta, bëhen publike me anë të afishimit apo postimit në faqen zyrtare të internetit, brenda 48 orëve prej miratimit të aktit nga AP.
              Në programin e transparencës janë të specifikuara kategoritë e informacionit të detyrueshëm për t’u bërë publik, mënyra e publikimit, si dhe parashikimet ligjore prej të cilave lind detyrimi për publikim. Në publikimin e informacionit, AP duhet të mbajnë parasysh interesin e publikut si dhe të mundësojnë aksesimin lehtësisht në informacionin publik.
            </p>
          </div>
    </>),
    2: (<>
<h1 id={'transparency-section-2'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>2. RRETH AUTORITETIT</h1>
          <div className={'px-4 mt-4'}>
            <div className={'py-2'}>
              <a href={'/about-us/structure'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Struktura organizative/Organigrama</a>
            </div>
            <div className={'py-2'}>
              <a href={'/salary.pdf'} target={'_blank'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Struktura e pagave</a>
            </div>
            <div className={'py-2'}>
              <a href={'/about-us/mission'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Funksionet dhe detyrat e A.P</a>
            </div>
            <div className={'py-2'}>
              <a className={'font-semibold'}>CV-të dhe pagat e nënpunësve që janë subjekt deklarimi sipas ligjit, përfshirë dhe anëtarët e kabinetit të titullarit të AP, përshkrim të  procedurës së zgjedhjes, kompetencat dhe detyrat e tyre</a>
              </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Procedura që ndjekin funksionarët e lartë të AP për të marrë vendime</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Procedurat dhe mekanizmat për të bërë kërkesë dhe ankesë që lidhen me veprimet ose mosveprimet e AKUK ( Përfshirë adresën postare/elektronike për depozitimin e kërkesave dhe ankesave – Afatet dhe mënyrën e kthimit të përgjigjeve)</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    3: (<>
<h1 id={'transparency-section-3'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>3. KUADRI LIGJOR RREGULLATOR</h1>
          <div className={'px-4 mt-4'}>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Legjislacion ndërkombëtar</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <a href={'/about-us/legal-framework'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Legjislacion kombëtar</a>
            </div>
            <div className={'py-2'}>
              <a href={'/about-us/legal-framework'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Akte nënligjore</a>
            </div>
            <div className={'py-2'}>
              <a target={'_blank'} href={'https://backoffice.akuk.gov.al/storage/163/Rregullore-AKUM-(1).pdf'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Rregullore/Kodi i sjelljes</a>
            </div>
            <div className={'py-2'}>
              <a target={'_blank'} href={'https://backoffice.akuk.gov.al/storage/163/Rregullore-AKUM-(1).pdf'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Aktet që përmbajnë rregulla, norma apo kufizime të të drejtave dhe lirive themelore të individit</a>
            </div>
            <div className={'py-2'}>
              <a href={'/publications/other'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Strategji</a>
            </div>
            <div className={'py-2'}>
              <a href={'/publications/reports'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Raport Vjetor</a>
            </div>
            <div className={'py-3'}>
              <p className={'font-semibold'}>Manuale/dokument politikash, që ka lidhje me funksionet e AKUK dhe që prek publikun</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    4: (<>
<div id={'transparency-section-4'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'mt-8'}>
            <a href={'/publications/info'} className={'text-primary-400  hover:text-primary-200 text-xl font-bold underline'}>4. E DREJTA PËR T'U INFORMUAR DHE PËR T'U ANKUAR</a>
          </div>
    </>),
    5: (<>
<h1 id={'transparency-section-5'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>5. MEKANIZMAT KONTROLLUES DHE MONITORUES QË VEPROJNË MBI AKUK</h1>
          <div className={'px-4 mt-4'}>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Rezolutë e Kuvendit të Shqipërisë (nëse ka të tillë)</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Planet strategjike të punës</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Raporte monitorimi/auditimi (p.sh:KLSH)</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Dokumente të tjera që përmbajnë tregues të performancës së AKUK</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    6: (<>
<h1 id={'transparency-section-6'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>6.	INFORMACION MBI BUXHETIN DHE TË DHËNAT FINANCIARE TË AKUK</h1>
          <div className={'px-4 mt-4'}>
            <div className={'py-2'}>
              <a href={'/about-us/budget'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Buxheti, plani i shpenzimeve për vitin financiar në vijim dhe vitet e kaluara</a>
            </div>
            <div className={'py-2'}>
              <a href={'/about-us/budget'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Raport vjetor për zbatimin e buxhetit dhe anekset</a>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Donacione, sponsorizime</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Dokumente që tregojnë gjendjen e shlyerjes së detyrimeve nga subjektet e licencuara</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    7: (<>
<h1 id={'transparency-section-7'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>7.	INFORMACION PËR PROCEDURAT E PROKURIMIT/PROCEDURAT KONKURRUESE TË KONCESIONIT/PARTNERITETIT PUBLIK PRIVAT</h1>
          <div className="px-4 mt-4">
            <div className={'py-2'}>
              <p className={'font-semibold'}>Lista e kontratave të lidhura (përfshirë shumën e kontraktuar, palët kontraktuese dhe përshkrimin e shërbimeve)</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Regjistri i parashikimeve të prokurimit publik</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Regjistri i realizimeve të prokurimit publik</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Informacion mbi zbatimin dhe monitorimin e kontratave, si dhe udhëzues e politika të ndryshme</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    8: (<>
<h1 id={'transparency-section-8'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>8.	SHËRBIMET QË OFROHEN NGA AKUK</h1>
          <div className="px-4 mt-4">
            <p className={'text-sm text-gray-600'}>Nuk ka</p>
          </div>
    </>),
    9: (<>
<h1 id={'transparency-section-9'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>9.	PROCEDURAT/MEKANIZMAT PËR TË DHËNË MENDIME LIDHUR ME PROCESIN E HARTIMIT TË AKTEVE LIGJORE/NËNLIGJORE, POLITIKAVE PUBLIKE APO NË LIDHJE ME USHTRIMIN E FUNKSIONEVE TË AKUK </h1>
          <div className="px-4 mt-4">
            <div className={'py-2'}>
              <p className={'font-semibold'}>Njoftimi dhe konsultimi publik (Linku)</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Komente/Rekomandime/Opinione të palëve të interesuara/grupe interesi</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Shqyrtimi i komenteve dhe rekomandimeve</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Raportet vjetore për transparencën në procesin e vendimmarrjes</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Procedura/mekanizma për të dhënë mendime lidhur me hartimin e politikave publike apo ushtrimin e funksioneve të AP</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Emër mbiemër të koordinatorit për konsultimin publik, adresë postare/elektronike</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    10: (<>
<h1 id={'transparency-section-10'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>10. SISTEMI I MBAJTJES SË DOKUMENTACIONIT, LLOJET DHE FORMAT E DOKUMENTEVE</h1>
          <div className="px-4 mt-4">
            <div className={'py-2'}>
              <p className={'font-semibold'}>Lista e dokumenteve që administrohen nga AKUK me afatet e ruajtjes</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
            <div className={'py-2'}>
              <p className={'font-semibold'}>Formën e dokumenteve/informacioneve (elektronik, kopje fizike, audio, video, foto)</p>
              <p className={'text-sm text-gray-600 mt-1'}>Nuk ka</p>
            </div>
          </div>
    </>),
    11: (<>
<div id={'transparency-section-11'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'mt-8'}>
            <a href={'/publications/request-register'} className={'text-primary-400  hover:text-primary-200 text-xl font-bold underline'}>11. REGJISTRI I KËRKESAVE DHE PËRGJIGJEVE I PËRDITËSUAR (SIPAS MODELIT TË REGJISTRIT TË MIRATUAR NGA KOMISIONERI)</a>
          </div>
    </>),
    12: (<>
<h1 id={'transparency-section-12'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>12. NDIHMA SHOQËRORE/SUBVENCIONE TË DHËNA NGA AKUK</h1>
          <div className="px-4 mt-4">
            <p className={'text-sm text-gray-600'}>Nuk ka</p>
          </div>
    </>),
    13: (<>
<h1 id={'transparency-section-13'} tabIndex={-1} style={{scrollMarginTop: '24px'}} className={'text-xl font-bold mt-8'}>13. INFORMACIONE/DOKUMENTE QË KËRKOHEN MË SHPESH DHE ATO QË GJYKOHEN TË DOBISHME PËR PUBLIKIM NGA AKUK</h1>
          <div className="px-4 mt-4">
            <div className={'py-2'}>
              <a href={'/publications/other'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Njoftime të ndryshme</a>
            </div>
            <div className={'py-2'}>
              <a href={'/publications/vacancies'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Njoftime për procedurat e rekrutimit/pranimit në shërbim civil</a>
            </div>
            <div className={'py-2'}>
              <a href={'/publications/reports'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Raporte</a>
            </div>
            <div className={'py-2'}>
              <a href={'/publications'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Publikime</a>
            </div>
            <div className={'py-2'}>
              <a href={'/projects'} className={'underline text-primary-400  hover:text-primary-200 font-semibold'}>Projekte</a>
            </div>
          </div>
    </>),
    14: (<h1 id={'transparency-section-14'} className={'text-xl font-bold'}>14. Të dhënat e hapura</h1>)
  };
  return (
    <Layout>
      <div className={'my-10 w-full lg:w-4/5 px-3 sm:px-5 md:px-10 lg:px-0 mx-auto'}>
        <PageHeader title={t('publications.transparencyProgram')} />
        <div className={'w-full p-10 bg-white'}>
          {category ? (
            <>
              <a href="/publications/transparency-program/show" className="inline-block mb-6 text-primary-400 underline font-semibold">
                ← {i18n.language === 'en' ? 'Back to the Transparency Program' : 'Kthehu te Programi i Transparencës'}
              </a>
              {typeof sectionHtml === 'string' ? (
                <div id={'transparency-section-' + category.id} className="transparency-section-content" dangerouslySetInnerHTML={{__html: sectionHtml}} />
              ) : sectionContent[category.id]}
              <div className="mt-8">
                <h2 className="text-xl font-bold mb-4">{i18n.language === 'en' ? 'Documents' : 'Dokumente'}</h2>
                {documents.length === 0 && <p className="text-sm text-gray-600">{i18n.language === 'en' ? 'No documents have been published in this category yet.' : 'Ende nuk ka dokumente të publikuara në këtë kategori.'}</p>}
                {documents.map(item => {
                  const files = item.file?.length ? item.file : (item.media || []);
                  return files.map(file => {
                    const url = file.original_url || file.url;
                    if (!url) return null;
                    return <a key={item.id + '-' + file.id} href={url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 border rounded-xl px-4 py-4 mb-3 text-primary-400 hover:text-primary-200">
                      <MdOutlinePictureAsPdf className="flex-shrink-0" aria-hidden="true" />
                      <span className="break-words min-w-0">{item['title_' + i18n.language] || item.title_al || item.title_en || file.file_name}</span>
                    </a>;
                  });
                })}
              </div>
            </>
          ) : (
<>
          {/* Transparency Program Schema Grid */}
          <div className={'mt-16 mb-10'}>
            <div className={'grid grid-cols-1 gap-4'}>
              {/* Top centered card - Programi i Transparencës */}
              <div className={'flex justify-center'}>
                <a href={sectionUrl(1)} className={'w-full md:w-2/3 lg:w-1/2 bg-primary text-white rounded-2xl p-6 text-center shadow-lg'}>
                  <h3 className={'text-xl font-bold'}>{transparencySchema[0].title}</h3>
                  <p className={'text-sm mt-1 opacity-90'}>{transparencySchema[0].subtitle}</p>
                </a>
              </div>

              {/* Row 1 - 3 cards */}
              <div className={'grid grid-cols-1 md:grid-cols-3 gap-4 mt-2'}>
                {transparencySchema.filter(item => item.row === 1).map((item) => (
                  <a
                    href={sectionUrl(item.id)}
                    key={item.id}
                    className={'bg-primary text-white rounded-2xl p-6 shadow-lg flex flex-col justify-center items-center text-center min-h-[120px]'}
                  >
                    <h4 className={'text-base font-semibold leading-tight'}>{item.title}</h4>
                    {item.subtitle && <p className={'text-xs mt-2 opacity-90'}>{item.subtitle}</p>}
                  </a>
                ))}
              </div>

              {/* Row 2 - 3 cards */}
              <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                {transparencySchema.filter(item => item.row === 2).map((item) => (
                  <a
                    href={sectionUrl(item.id)}
                    key={item.id}
                    className={'bg-primary text-white rounded-2xl p-6 shadow-lg flex flex-col justify-center items-center text-center min-h-[120px]'}
                  >
                    <h4 className={'text-base font-semibold leading-tight'}>{item.title}</h4>
                    {item.subtitle && <p className={'text-xs mt-2 opacity-90'}>{item.subtitle}</p>}
                  </a>
                ))}
              </div>

              {/* Row 3 - 3 cards */}
              <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                {transparencySchema.filter(item => item.row === 3).map((item) => (
                  <a
                    href={sectionUrl(item.id)}
                    key={item.id}
                    className={'bg-primary text-white rounded-2xl p-6 shadow-lg flex flex-col justify-center items-center text-center min-h-[120px]'}
                  >
                    <h4 className={'text-base font-semibold leading-tight'}>{item.title}</h4>
                    {item.subtitle && <p className={'text-xs mt-2 opacity-90'}>{item.subtitle}</p>}
                  </a>
                ))}
              </div>

              {/* Final rows share a grid so the open-data card matches the request-register card. */}
              <div className={'grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-fr'}>
                {transparencySchema.filter(item => item.row === 4 || item.row === 5).map((item) => (
                  <a
                    href={sectionUrl(item.id)}
                    key={item.id}
                    className={'bg-primary text-white rounded-2xl p-6 shadow-lg flex flex-col justify-center items-center text-center min-h-[120px]'}
                  >
                    <h4 className={'text-base font-semibold leading-tight'}>{item.title}</h4>
                    {item.subtitle && <p className={'text-xs mt-2 opacity-90'}>{item.subtitle}</p>}
                  </a>
                ))}
              </div>
            </div>
          </div>

</>
          )}
        </div>
      </div>
    </Layout>
  );
};
export default ShowTransparencyProgramPage;
